import { render, staticRenderFns } from "./JourneyAttractionDetails.vue?vue&type=template&id=288ac646&scoped=true"
import script from "./JourneyAttractionDetails.vue?vue&type=script&lang=js"
export * from "./JourneyAttractionDetails.vue?vue&type=script&lang=js"
import style0 from "./JourneyAttractionDetails.vue?vue&type=style&index=0&id=288ac646&prod&scoped=true&lang=css"
import style1 from "./JourneyAttractionDetails.vue?vue&type=style&index=1&id=288ac646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ac646",
  null
  
)

export default component.exports